<div appModal [closeOnClickOutside]="false" (closeModal)="close()">
  <form class="p-20" (submit)="setupAccount($event)" [formGroup]="setupAccountForm">
    <h2 class="text-center mb-40">Set up your account</h2>
    <p class="text-center mb-40">
      Already have an account? <a href="" class="text-blue" (click)="signIn($event)">Sign In</a>
    </p>

    <div class="modal-content-container">
      <div>
        <div class="flex justify-between items-center">
          <span>Account type:</span>
          <div class="user-type-selection flex">
            <div
              class="input input-radio ml-12"
              *ngFor="let type of userTypes"
              [class.active]="type === setupAccountForm.get('type').value"
            >
              <label>
                <input formControlName="type" type="radio" [value]="type" />
                <span class="selector"></span>
                {{ type | titlecase }}
              </label>
            </div>
          </div>
        </div>

        <div class="row flex mt-20">
          <div>
            <div
              class="input input-text input-no-min"
              [class.input-error]="formHelpersService.isInputInvalid(setupAccountForm, 'firstName')"
            >
              <input type="text" placeholder="First Name" formControlName="firstName" />
            </div>
            <label class="input-error-message" *ngIf="formHelpersService.isInputInvalid(setupAccountForm, 'firstName')">
              Please enter your first name
            </label>
          </div>

          <div>
            <div
              class="input input-text input-no-min ml-7"
              [class.input-error]="formHelpersService.isInputInvalid(setupAccountForm, 'lastName')"
            >
              <input type="text" placeholder="Last Name" formControlName="lastName" />
            </div>
            <label class="input-error-message" *ngIf="formHelpersService.isInputInvalid(setupAccountForm, 'lastName')">
              Please enter your last name
            </label>
          </div>
        </div>

        <div
          class="input input-text input-no-max mt-20"
          [class.input-error]="formHelpersService.isInputInvalid(setupAccountForm, 'email')"
        >
          <input type="email" placeholder="Email" formControlName="email" autocomplete="username" />
          <div *ngIf="setupAccountForm.get('email').pending" class="loader">
            <div class="ball1"></div>
            <div class="ball2"></div>
            <div class="ball3"></div>
          </div>
        </div>
        <label class="input-error-message" *ngIf="formHelpersService.hasError(setupAccountForm, 'email', 'email')">
          Please enter a valid email Address
        </label>
        <label
          class="input-error-message"
          *ngIf="formHelpersService.hasError(setupAccountForm, 'email', 'emailExists')"
        >
          This email address is already in use
        </label>
        <label
          class="input-error-message"
          *ngIf="formHelpersService.hasError(setupAccountForm, 'email', 'sameAsAthleteEmail')"
        >
          Parent & Athlete email can not be the same
        </label>

        <div
          class="input input-text input-no-max relative mt-20 items-center pr-10"
          [class.input-error]="formHelpersService.isInputInvalid(setupAccountForm, 'password')"
        >
          <input
            [type]="showPassword ? 'text' : 'password'"
            placeholder="Password"
            formControlName="password"
            autocomplete="new-password"
          />

          <svg-icon
            src="assets/images/svg/icons/misc/views.svg"
            (mousedown)="toggleShowPassword()"
            (mouseup)="toggleHidePassword()"
            (touchstart)="toggleShowPassword()"
            (touchend)="toggleHidePassword()"
          >
          </svg-icon>
        </div>
        <label
          class="input-error-message"
          *ngIf="formHelpersService.hasError(setupAccountForm, 'password', 'required')"
        >
          Please create a password
        </label>
        <label
          class="input-error-message"
          *ngIf="formHelpersService.hasError(setupAccountForm, 'password', 'minlength')"
        >
          Password is too short
        </label>

        <hr *ngIf="invites.length" />

        <div class="athlete-container" *ngIf="invites.length">
          <h3 class="text-center mb-10">Athlete Information</h3>
          <p class="text-center">Your athlete will be automatically linked to your account</p>

          <div
            class="event-invite-container mt-20 pb-20"
            *ngFor="let invite of invites; index as i"
            [formGroup]="invite.form"
          >
            <h3 class="mb-0" *ngIf="invite.eventName">Event: {{ invite.eventName }}</h3>
            <h3 class="mb-0" *ngIf="!invite.eventName">{{ invite.purchaseType }}</h3>
            <div
              class="input input-text mt-10"
              [class.input-error]="formHelpersService.isInputInvalid(invite.form, 'athleteName')"
            >
              <input type="text" placeholder="Athlete Name" formControlName="athleteName" />
            </div>

            <div
              class="input input-text mt-20"
              [class.input-error]="formHelpersService.isInputInvalid(invite.form, 'email')"
            >
              <input type="email" placeholder="Email" formControlName="email" />
            </div>
            <label
              class="input-error-message"
              *ngIf="formHelpersService.hasError(invite.form, 'email', 'sameUserEmail')"
            >
              Parent & Athlete email can not be the same
            </label>
          </div>
        </div>

        <div class="flex justify-between mt-20">
          <div>
            <div class="input input-checkbox">
              <label>
                <input formControlName="ageCheckmark" tabIndex="1" type="checkbox" />
                <span class="selector"></span>
                <span class="label">I am over 13 years of age</span>
              </label>
            </div>
            <p class="text-red mt-10" *ngIf="formHelpersService.isInputInvalid(setupAccountForm, 'ageCheckmark')">
              Sorry, but you don't meet NextPro's age requirements to create an account.
            </p>

            <div class="input input-checkbox mt-15">
              <label>
                <input type="checkbox" tabIndex="2" formControlName="rememberMe" />
                <span class="selector"></span>
                <span class="label">Remember Me</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-actions-container">
      <button (click)="setupAccount($event)" class="btn btn-lg">Continue</button>
    </div>
  </form>
</div>
